import React from 'react'
import { Link } from 'gatsby'

export default ({ content, white, blue }) => {
    let classText = "btn"
    if(white)
        classText += " btn-white"
    if(blue)
        classText += " btn-blue"

    if ( content.buttonLink != null ) {
        if ( content.buttonLink.startsWith("/") ) {
            // The link is internal
            return (
                <Link className={ classText }
                      to={content.buttonLink}>{ content.buttonText }</Link>
            )
        } else {
            return (
                <a className={ classText }
                href={content.buttonLink}>{ content.buttonText }</a>
            )
        }
    } else {
        return (
            <Link className={ classText }
                to="#">Not Found</Link>
        )
    }
}
